import {computeRightLegend} from './computeRightLegend';
import { HOUR_IN_SECONDS } from '@v2/pages/common/constants/base.constants';

export const computeFormattedData = (dataBar: any[], heightValues: string[], isDay: boolean) => {
  let formatedData = dataBar.map((item) => ({
    ...item,
    total: heightValues.reduce((a: number, key: string) => item[key] + a, 0),
  }));

  const maxValue = Math.max(...formatedData.map((i) => i.total));
  const rightLegend = computeRightLegend(maxValue, isDay);
  const topPoint = rightLegend[2] * HOUR_IN_SECONDS;

  formatedData = formatedData.map((item) => {
    const height: Record<string, number> = {};
    heightValues.forEach((key) => {
      height[key + 'Height'] = (item[key] * 100) / topPoint;
    });
    return {
      ...item,
      height: (item.total * 100) / topPoint,
      ...height,
    };
  });

  return { formatedData, rightLegend, maxValue };
};